import { render, staticRenderFns } from "./ExchangeCodePopup.vue?vue&type=template&id=6b24e010&scoped=true"
import script from "./ExchangeCodePopup.vue?vue&type=script&lang=js"
export * from "./ExchangeCodePopup.vue?vue&type=script&lang=js"
import style0 from "./ExchangeCodePopup.vue?vue&type=style&index=0&id=6b24e010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b24e010",
  null
  
)

export default component.exports